module.exports = __webpack_public_path__ + "img/app_android.98f6ff53.png";